import { markdown } from "../markdown.js";

export const welcome_custom = () => markdown`

No official reporter for your test runner? Three options:

- **Use JUnit XML.** Most test runners can emit JUnit XML. Pick the **JUnit XML** tile and follow the convert + upload flow.
- **File an issue.** Request an official integration on the [flakiness-feedback](https://github.com/flakiness/flakiness-feedback) repo.
- **Write your own.** If you're on Node.js, use the [Node.js SDK](https://github.com/flakiness/nodejs-sdk), which handles git detection, CI detection, and report upload. Otherwise, generate reports conforming to the [Flakiness JSON Report spec](https://github.com/flakiness/flakiness-report).
`;
